"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.parse-int");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var theme_1 = require("../../styles/theme"); // TODO: use integers in theme.ts instead of '16px'


var baseFontSize = Number.parseInt(theme_1.theme.baseFontSize, 10);
exports.H1 = styled_1["default"]('h1')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'Apercu Pro Bold', sans-serif;\n  font-size: ", "px;\n"], ["\n  font-family: 'Apercu Pro Bold', sans-serif;\n  font-size: ", "px;\n"])), baseFontSize * 3.75);
exports.H2 = styled_1["default"]('h2')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: 'Apercu Pro Bold', sans-serif;\n  font-size: ", "px;\n"], ["\n  font-family: 'Apercu Pro Bold', sans-serif;\n  font-size: ", "px;\n"])), baseFontSize * 3.75);
exports.H3 = styled_1["default"]('h3')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: 'SangBleu Sunrise Bold', sans-serif;\n  font-size: ", "px;\n"], ["\n  font-family: 'SangBleu Sunrise Bold', sans-serif;\n  font-size: ", "px;\n"])), baseFontSize * 2.5);
exports.H4 = styled_1["default"]('h4')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: 'Apercu Pro Bold', sans-serif;\n  font-size: ", "px;\n"], ["\n  font-family: 'Apercu Pro Bold', sans-serif;\n  font-size: ", "px;\n"])), baseFontSize * 2);
exports.H5 = styled_1["default"]('h5')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-family: 'Apercu Pro Bold', sans-serif;\n  font-size: ", "px;\n"], ["\n  font-family: 'Apercu Pro Bold', sans-serif;\n  font-size: ", "px;\n"])), baseFontSize * 1.5625);
exports.H6 = styled_1["default"]('h6')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-family: 'Apercu Pro Medium', sans-serif;\n  font-size: ", "px;\n  font-weight: 500;\n  letter-spacing: ", "px;\n  text-transform: uppercase;\n"], ["\n  font-family: 'Apercu Pro Medium', sans-serif;\n  font-size: ", "px;\n  font-weight: 500;\n  letter-spacing: ", "px;\n  text-transform: uppercase;\n"])), baseFontSize * 1.25, baseFontSize * 0.0975);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;